import { useMsal } from '@azure/msal-react';
import React, { createContext, useContext, useEffect, useState } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const { instance, accounts } = useMsal();
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Try to get user from accounts array first (standard web auth)
    if (accounts?.length > 0) {
      const activeAccount = accounts[0];
      setUser(activeAccount);
      return;
    }
    
    // If no accounts in array, check instance.getActiveAccount() (Teams NAA case)
    const activeAccount = instance.getActiveAccount();
    if (activeAccount) {
      setUser(activeAccount);
      return;
    }
    // No user found yet
    setUser(null);
  }, [accounts, instance]);

  // Listen for Teams NAA account being set
  useEffect(() => {
    const handleAccountSet = (event) => {
      console.log("Reactor: user debug: Received msal-account-set event");
      const account = event.detail?.account || instance.getActiveAccount();
      if (account) {
        console.log("Reactor: user debug: Setting user from custom event");
        setUser(account);
      }
    };

    window.addEventListener('msal-account-set', handleAccountSet);
    
    return () => {
      window.removeEventListener('msal-account-set', handleAccountSet);
    };
  }, [instance]);

  return (
    <AuthContext.Provider value={{ user, instance, accounts, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext)